const Step4 = () => {
  return <>Step 4</>
}

export default Step4;